import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  retainedPincode: {},
  loginDetail: {},
  fvId: "",
  lastSavedPincode: "",
};

//FUS gets the data for login,cart quatity and pincode retention detail of user
export const FusSlice = createSlice({
  name: "fusSlice",
  initialState,
  reducers: {
    initiateFus: (state) => {
      return {
        ...state,
      };
    },
    setFusData: (state, action) => {
      return {
        ...state,
        loginDetail: action.payload?.checklogin,
        fvId: action.payload?.fvId,
        retainedPincode: action.payload?.pincodeGivenByUser,
        lastSavedPincode: action.payload?.cart?.lastSavedPincode,
      };
    },
  },
});

export default FusSlice.reducer;
export const { initiateFus, setFusData } = FusSlice.actions;
